import React from "react";
import { Link, NavLink } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import logo from "../assets/logo3.webp";

export default function Header() {
  return (
    <Navbar expand="xxl">
      <Container>
        <NavLink to="/">
          <img className="customlogo img-fluid" src={logo} alt="logo" />
        </NavLink>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse
          id="basic-navbar-nav"
          className="justify-content-center gap-md-3 "
        >
          <Nav className="nav-custom gap-0 gap-md-3">
            <NavLink className="nav-link" to="/">
              Home
            </NavLink>
            <NavLink className="nav-link" to="/why-andromeda-sim">
              Why Andromeda-Sim?
            </NavLink>
            <NavLink className="nav-link" to="/features">
              Features
            </NavLink>
            <NavLink className="nav-link" to="/roadmap">
              RoadMap
            </NavLink>

            <NavLink  className="nav-link" to="/training">Training</NavLink>
            <NavLink className="nav-link" to="/contact-us">
              Contact Us
            </NavLink>
            

            <div className="d-block d-xxl-flex nav_buttons_div d-block d-xxl-none">

              <a
                href="https://app.andromeda-sim.com/login"
                rel="noopener noreferrer"
              >
                <button className="btn-login">Login</button>
              </a>

                            <a
                href="https://app.andromeda-sim.com/signup"
                rel="noopener noreferrer"
              >
                <button className="btn-signup whitespace-nowrap">
                  Sign Up
                </button>
              </a>
            </div>
          </Nav>
        </Navbar.Collapse>
        <div className="d-block d-xxl-flex nav_buttons_div d-none d-xxl-block">

          <a
            href="https://app.andromeda-sim.com/login"
            rel="noopener noreferrer"
          >
            <button className="btn-login">Login</button>
          </a>

                    <a
            href="https://app.andromeda-sim.com/signup"
            rel="noopener noreferrer"
          >
            <button className="btn-signup whitespace-nowrap">Sign Up</button>
          </a>
          
        </div>
      </Container>
    </Navbar>
  );
}
